/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useEffect, useState } from 'react';

import { cssMap, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import trafficLightsSvg from '../../assets/traffic-lights.svg';

import { HeaderActions } from './HeaderActions';
import { TerminalBody } from './TerminalBody';
import type { Os } from './types';
import { detectOs } from './utils';

const styles = cssMap({
	window: {
		width: '100%',
		maxWidth: '800px',
		display: 'flex',
		flexDirection: 'column',
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		backgroundColor: '#111213',
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		borderColor: '#292A2E',
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-shape
		borderRadius: '12px',
		overflow: 'hidden',
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		borderBlockEndWidth: token('border.width'),
		borderBlockEndStyle: 'solid',
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		borderBlockEndColor: '#292A2E',
	},
	trafficLights: {
		display: 'block',
		width: '52px',
		height: '12px',
		flexShrink: 0,
	},
});

export const TerminalWindow = (): JSX.Element => {
	// Default to a stable value for SSR, then refine to the detected OS once
	// the browser has hydrated. This avoids a hydration-mismatch warning while
	// still picking the right OS for the user on first paint after mount.
	const [selectedOs, setSelectedOs] = useState<Os>('macos');
	useEffect(() => {
		setSelectedOs(detectOs());
	}, []);

	return (
		<div css={styles.window}>
			<div css={styles.header}>
				<img css={styles.trafficLights} src={trafficLightsSvg} alt="" aria-hidden="true" />
				<HeaderActions selectedOs={selectedOs} onSelectOs={setSelectedOs} />
			</div>
			<TerminalBody os={selectedOs} />
		</div>
	);
};
